/**
 * base on application/models/React/States/User.php
 */
export const USER_OPTIONS = {
  IS_GMAIL_INVITE_AVAILABLE: 'isGmailInviteAvailable',
  IS_CANDIDATE_EMAIL_CONFIRM: 'EmailAddressConfirm',
  HAS_RESUME: 'hasResume',
  HAS_COMPLIED_GAT: 'hasCompliedGat',
  HAS_RECOMMENDATION: 'hasRecommendation',
  HAS_CANDIDATE_ACCOUNT: 'hasCandidateAccount',
  HAS_RECRUITER_CALENDAR: 'hasRecruiterCalendar',
};

export default USER_OPTIONS;
